<script lang="ts">
  import { slide, fade } from 'svelte/transition';
  import { cubicOut } from 'svelte/easing';

  let { children }: { children: import('svelte').Snippet } = $props();

  const slideOptions = { duration: 300, easing: cubicOut, axis: 'y' };
</script>

<div class="screen-wrapper" in:slide={slideOptions} out:fade={{ duration: 150 }}>
  {@render children()}
</div>

<style>
  .screen-wrapper {
    display: contents;
  }
</style>
